import uniq from 'lodash-es/uniq'

import type { Product } from '../../../../../../../../../__models__'

export const getEstimatedProductionTime = (product: Product) => {
  const variantsProductionTimeFrom = Math.min(
    ...uniq(product.variants.map((item) => item.productionTime.daysFrom)),
  )
  const variantsProductionTimeTo = Math.max(
    ...uniq(product.variants.map((item) => item.productionTime.daysTo)),
  )

  return {
    from: variantsProductionTimeFrom,
    to: variantsProductionTimeTo,
  }
}
